import React from 'react';
import Icon from 'components/lib/icons/icon';

/**
 * @visibleName Forward
 */

export default function DragPointerIcon(props) {
  return (
    <Icon viewBox="0 0 16 16" {...props}>
      <g>
        <circle cx="5.5" cy="2.5" fill="#919191" r="1.5" />
        <circle cx="5.5" cy="7.5" fill="#919191" r="1.5" />
        <circle cx="5.5" cy="12.5" fill="#919191" r="1.5" />
        <circle cx="10.5" cy="2.5" fill="#919191" r="1.5" />
        <circle cx="10.5" cy="7.5" fill="#919191" r="1.5" />
        <circle cx="10.5" cy="12.5" fill="#919191" r="1.5" />
      </g>
    </Icon>
  );
}
